var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconGames = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("g", { transform: "translate(-61.757 -431.419)" },
                    React.createElement("path", { d: "M79.9,435.3c-1,0-3,1.5-4.7,1.5c-1.7,0-3.8-1.5-4.7-1.5c-6.2,0-9.8,16.7-5.1,16.7\n\t\t\tc3.9,0,4.4-4.9,9.8-4.9c4.3,0,6.9,4.8,9.8,4.8C89.6,452,86.1,435.3,79.9,435.3z" }),
                    React.createElement("g", { transform: "translate(67.287 440.162)" },
                        React.createElement("path", { d: "M15.8,4c0,0.6-0.5,1.2-1.2,1.2c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2l0,0\n\t\t\t\tC15.2,2.8,15.8,3.3,15.8,4C15.8,4,15.8,4,15.8,4z" }),
                        React.createElement("path", { d: "M2.7,4c0,0.6-0.5,1.2-1.2,1.2S0.4,4.6,0.4,4S1,2.8,1.6,2.8S2.7,3.3,2.7,4L2.7,4z" }))),
                React.createElement("g", { transform: "translate(-61.757 -431.419)" },
                    React.createElement("path", { d: "M66.4,452.5c0,2.3,0.6,5,2.1,5c3.9,0,4.4-4.9,9.8-4.9c4.3,0,6.9,4.8,9.8,4.8c3.9,0,2.1-11.6-2.2-15.4" }),
                    React.createElement("path", { d: "M70,445.5" })),
                React.createElement("path", { d: "M11.8,18c0,0.6-0.5,1.2-1.2,1.2c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2\n\t\tC11.3,16.8,11.8,17.3,11.8,18L11.8,18z" })))));
});
export default IconGames;
//# sourceMappingURL=IconGames.js.map